import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import ForgotPasswordForm from '@/components/forms/forgot-password-form'
import { AuthSplitLayout } from '@/components/layout/auth-split-layout'

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordPage,
})

function ForgotPasswordPage() {
  const { t } = useTranslation()

  return (
    <AuthSplitLayout>
      <div className="flex-1 flex flex-col justify-center w-full md:flex-none md:mb-6 md:space-y-6 ">
        <div className="flex flex-col gap-y-3">
          <h1 className="heading-1 text-center">{t('forgotPasswordPage.title')}</h1>
          <p className="body-1 text-text-secondary text-center">
            {t('forgotPasswordPage.description')}
          </p>
        </div>
      </div>

      <div className="w-full gap-6 flex flex-col">
        <ForgotPasswordForm />
      </div>
    </AuthSplitLayout>
  )
}
